import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as Connection from "./../libs/connections";

import Preloader from "./../components/global/Preloader";
import HeroBanner from "./../components/HeroBanner";
import ModuleRentalSale from "../components/ModuleRentalSale";
import SectionRoad from "../components/SectionRoad";
import ShowroomFullScreen from "../components/ShowroomFullScreen";
import SectionOfferButtons from "../components/SectionOfferButtons";

import heroBackground from "../assets/backgrounds/hero-offer.jpg";

export default class OfferData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    try {
      const response = await Connection.getPageBySlug("oferta");
      this.setState({
        loading: false,
        offerData: response.acf,
        bannerShowRoom: response.acf.showroom.photoUrl
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  render() {
    return (
      <div className="page-offer">
        <Preloader global loading={this.state.loading} />
        <HeroBanner fulljustify backgroundImage={heroBackground} headerText="All ready to ride" showFooter={false} />
        {this.state.offerData && <ModuleRentalSale data={this.state.offerData} />}
        {this.state.offerData && <SectionRoad data={this.state.offerData} />}
        {this.state.offerData &&
          this.state.offerData.showroom && (
            <ShowroomFullScreen
              backgroundImage={this.state.offerData.showroom.photoUrl}
              text={
                <div className="showroom-text">
                  <div className="container container-small">
                    <div className="row">
                      <div className="col-12">
                        <h5>
                          <span>{this.state.offerData.showroom.titleMain}</span>
                          {this.state.offerData.showroom.titleSecond}
                        </h5>
                        <p dangerouslySetInnerHTML={{ __html: this.state.offerData.showroom.desc }} />
                        <Link className="btn-general btn-general--primary" to={this.state.offerData.showroom.button.buttonUrl}>
                          {this.state.offerData.showroom.button.buttonText}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
          )}
        <SectionOfferButtons type="all" />
      </div>
    );
  }
}
